import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import ServiceMap from './components/ServiceMap';
import Contact from './components/Contact';
import QuoteModal from './components/QuoteModal';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => setIsQuoteModalOpen(true);
  const closeQuoteModal = () => setIsQuoteModalOpen(false);

  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-slate-50" data-testid="app-container">
        <Toaster 
          position="top-right" 
          richColors 
          closeButton
          toastOptions={{
            style: {
              borderRadius: '0',
            },
          }}
        />
        
        <Navbar onQuoteClick={openQuoteModal} />
        
        <main>
          <Hero onQuoteClick={openQuoteModal} />
          <Services onQuoteClick={openQuoteModal} />
          <About />
          <ServiceMap />
          <Contact />
        </main>

        <Footer />

        <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
      </div>
    </BrowserRouter>
  );
}

export default App;
